import { render, staticRenderFns } from "./_siteDeletedNotification.vue?vue&type=template&id=3958d06a&scoped=true"
import script from "./_siteDeletedNotification.vue?vue&type=script&lang=js"
export * from "./_siteDeletedNotification.vue?vue&type=script&lang=js"
import style0 from "./_siteDeletedNotification.vue?vue&type=style&index=0&id=3958d06a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3958d06a",
  null
  
)

export default component.exports